var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.add)?_c('span',{staticClass:"icon icon-add",on:{"click":_vm.addItem}}):_vm._e(),(this.copy)?_c('span',{staticClass:"icon icon-duplicate",on:{"click":_vm.copyItem}}):_vm._e(),(this.delete)?_c('span',{staticClass:"icon icon-delete",on:{"click":_vm.deleteItem}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }